import { defineComponent as _defineComponent } from 'vue'
import { SERVICE_UID } from "@/types";
import Page from "@/components/shared/Page.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import { useRoute } from "vue-router";


const __default__ = {
  name: "Auth",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const path = route.query.path ?? "";
const scriptUrl = process.env.VUE_APP_AUTH_SCRIPT_URL;

const recaptchaScript = document.createElement("script");
recaptchaScript.setAttribute("src", `${scriptUrl}`);
recaptchaScript.onload = () => {
  initPopupAuth();
};
document.head.appendChild(recaptchaScript);

const initPopupAuth = () => {
  setTimeout(() => {
    window.eziok_std_process(
      `${process.env.VUE_APP_API_URL}/aibos/client/api/v1/public/service/${SERVICE_UID}/auth/eziok/${path}`,
      "MB",
      ""
    );
  }, 500);
};

const __returned__ = { route, path, scriptUrl, recaptchaScript, initPopupAuth, Page, NavigationBar }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})